import React from "react";
import TextField from "@mui/material/TextField";
import DocumentLayout from "../../../components/Layouts/DocumentLayout";
import { useIntl } from "react-intl";

const DetailsSection = ({
  touched = {},
  errors = {},
  values,
  handleChange,
  handleBlur,
  validateField,
}) => {
  const { formatMessage } = useIntl();

  const handleBlurWithValidation = async (e) => {
    handleBlur(e);
    // Explicitly trigger validation
    if (validateField) {
      setTimeout(() => validateField(e.target.name), 0);
    }
  };

  return (
    <DocumentLayout>
      <TextField
        sx={{ mb: 2 }}
        error={!!(touched.subject && errors.subject)}
        label={formatMessage({ id: "ticket.create.detail.subject" })}
        id="subject"
        name="subject"
        value={values.subject}
        fullWidth
        onChange={handleChange}
        onBlur={handleBlurWithValidation}
        autoFocus
        helperText={
          touched.subject && errors.subject
            ? formatMessage({
                id: "ticket.create.detail.error.wrong_subject",
              })
            : ""
        }
      />

      <TextField
        sx={{ mb: 2 }}
        label={formatMessage({ id: "ticket.create.detail.place" })}
        error={!!(touched.place && errors.place)}
        id="place"
        name="place"
        fullWidth
        value={values.place}
        onChange={handleChange}
        onBlur={handleBlur}
        helperText={
          touched.place && errors.place
            ? formatMessage({
                id: "ticket.create.detail.error.invalid_place",
              })
            : ""
        }
      />

      <TextField
        sx={{ mb: 2 }}
        error={!!(touched.body && errors.body)}
        label={formatMessage({ id: "ticket.create.detail.details" })}
        id="body"
        name="body"
        value={values.body}
        multiline
        rows="4"
        fullWidth
        onChange={handleChange}
        onBlur={handleBlur}
        helperText={
          touched.body && errors.body
            ? formatMessage({
                id: "ticket.create.detail.error.invalid_description",
              })
            : ""
        }
      />
    </DocumentLayout>
  );
};

export default DetailsSection;
